<template>
  <div class="radioButton">
    <input
      type="radio"
      :name="name"
      :id="id"
      :value="value"
      :checked="currentValue === value"
      @change="callInputChange"
    />
    <label
      :class="['radioButton_label', { error, req, hasValue: currentValue }]"
      :for="id"
    >
      {{ label }}
    </label>
  </div>
</template>

<script lang="ts">
import { SetupContext } from 'vue'
import { HTMLElementEvent } from '@/types/HTMLElement'

export default {
  name: 'InputRadioButton',

  props: {
    id: String,
    label: String,
    name: String,
    error: {
      type: Boolean,
      default: false
    },
    req: {
      type: Boolean,
      default: false
    },
    value: String,
    currentValue: String
  },

  setup(props: any, context: SetupContext) {
    const callInputChange = (e: HTMLElementEvent<HTMLInputElement>) => {
      context.emit('call-input-change', e.target.value)
    }

    return {
      callInputChange
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.radioButton_label {
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  height: 50px;
  padding: 10px;
  border: 1px solid var.$color-border-gray;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
  line-height: 1.3;
  font-weight: 500;
  transition: border 0.1s ease;

  &::before {
    display: inline-block;
    content: '';
    width: 20px;
    height: 20px;
    margin-right: 10px;
    background-color: var.$color-border-gray;
    border-radius: 100%;
    flex-shrink: 0;
    transition: background 0.1s ease;
  }

  &::after {
    opacity: 0;
    position: absolute;
    top: 20px;
    left: 16px;
    display: inline-block;
    content: '';
    width: 8px;
    height: 8px;
    background-color: #fff;
    border-radius: 100%;
    transition: opacity 0.1s ease;
  }

  .radioButton > input[type='radio']:checked + & {
    border: 1px solid var.$color-main;
    &::before {
      background-color: var.$color-main;
    }
    &::after {
      opacity: 1;
    }
  }
}

.radioButton > input[type='radio'] {
  display: none;
}

.error {
  border-color: var.$color-red;
}
.req {
  background-color: #e7f8f6;
  &.hasValue {
    background-color: #fff;
  }
}
</style>
